import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { analytics } from '../modules/analytics';


export class UserBillingHistory extends React.Component {
  static propTypes = {
    networkError: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    analytics.trackView('/user/billing');
    // this.props.getBillingHistory();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.networkError && !this.props.networkError) {
      // this.props.getBillingHistory();
    }
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>My Billing</title>
        </Helmet>
        <h5 className="mb-4">Invoices</h5>
        <div>
          You don't have any invoices yet.
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/presentation/UserBillingHistory.jsx